export default {
  menu: {
    disk: '我的网盘',
    folder: '文件夹管理',
    log: '操作日志',
    dashboard: '仪表盘',
    department: '部门管理',
    role: '角色管理',
    user: '用户管理',
    down: '下载量查看',
    roleAdd: '创建角色',
  },
  button: {
    update: '编辑',
    edit: '修改',
    delete: '删除',
    downLoad: '下载',
    share: '分享',
    preview: '预览',
    action: '操作',
    search: '查询',
    reset: '重置',
    add: '创建',
    cancel: '取消',
    confirm: '确认',
    export: '导出',
    back: '上一步',
    close: '下一步',
    save: '保存',
    deleteConfirm: '确认删除',
    abled: '启用',
    disabled: '禁用',
    uploadFiles: '上传文件',
    downloadFiles: '下载文件',
    addFolder: '创建文件夹',
    copy: '复制',
    move: '移动',
    show: '显示',
    hide: '隐藏',
    backBefore: '返回上一级',
    clickToUpload: '点击上传',
    shutDown: '关闭',
    leaveConfirm: '确认离开',
    logout: '退出',
    more: '更多',
    upGo: '收起',
  },
  common: {
    pleaseInput: '请输入',
    pleaseWrite: '请填写',
    pleaseSelect: '请选择',
    pleaseTickFar: '请勾选协议',
    whole: '全部',
    searchRegion: 'regionCn',
    selPleaseDepart: '请选择部门及角色',
    noData: '暂无数据',
    uploadDrag: '将文件拖到此处或',
    uploadClick: '点击上传',
    iHaveReadAndAgree: '我已阅读并同意',
    userUseAgreement: '用户隐私政策',
    platformUsageProtocol: '平台使用协议',
    dealerHandbook: '经销商使用手册',
    pleaseSelectWiw: '请填写完整的wiw',
    410: '您的账号登录时间已超期，即将跳转登录...',
    401: '您目前无权访问当前系统',
  },
  table: {
    department: {
      name: '部门名称',
      attribute: '部门属性',
      localName: '根文件夹名称',
      lastEditUser: '最后编辑人',
      lastEditTime: '最后编辑时间',
      createdUser: '创建人',
      createdTime: '创建时间',
      description: '描述',
    },
    user: {
      userId: '用户ID',
      name: '姓名',
      departAndDelear: '所属业务部门/经销商名称',
      departAndRole: '所属部门/所属角色',
      status: '用户状态',
      department: '所属部门',
      role: '所属角色',
      businessDepartment: '所属业务部门',
      delaerCode: '经销商代码',
      delaerName: '经销商名称',
      delaerType: '用户类型',
      region: '区域',
      north: '北',
      south: '南',
      east: '东',
      west: '西',
      post: '岗位',
    },
    role: {
      name: '角色名称',
      description: '角色描述',
      allRole: '所有权限',
      roleProperties: '角色属性',
      menupermissions: '菜单权限',
    },
    file: {
      roleChecked: '是否设置用户权限',
      folderStructure: '文件夹结构',
      user: '用户',
      permissionSettings: '权限设置',
    },
    log: {
      id: '操作人ID',
      act: '操作',
      actTime: '操作时间',
      logContent: '日志内容',
      startTime: '开始时间',
      endTime: '结束时间',
      dealerBusinessDepartment: '所属经销商/业务部门',
      exportTip: '系统最多支持导出 10W 条数据，请调整导出时间范围以确保导出所有数据',
    },
    disk: {
      name: '名称',
      fileExpirationTime: '文件过期时间',
      route: '路径',
      files: '文件夹/文件',
      filesShare: '文件分享',
      linkExpirationTime: '链接过期时间',
      linkExpirationTimeT: '链接失效时间',
      shareUsers: '分享用户',
      generateLink: '生成链接',
      allDocuments: '全部文件',
      successfullyAdded: '成功添加',
      fail: '失败',
      theIDAccountIncorrect: '以下ID非有效账号',
      noFolder: '无文件夹',
      fileExpirationTip: '指平台定期清理1年保存期机制，不代表文件版权使用期限。',
    },
    dashboard: {
      fileSave: '文件存储',
      fileRelated: '文件相关',
      fileAccount: '文件总数',
      folderAccount: '文件夹总数',
      nearExpirationFiles: '临近过期文件',
      userAccount: '用户数量',
      onlineYesterday: '昨日在线',
      totalUsers: '总用户数',
      usedSpace: '已使用空间',
    },
    dashboardTap: {
      fileStatistics: '文件统计信息',
      dealerDownloads: '经销商下载统计',
      dealerUploadVolume: '经销商上传统计',
      fileAddition: '文件新增',
      folderAddition: '文件夹新增',
      numberOfDownloadsOfFiles: '下载文件次数',
      onlineUserVolume: '在线用户量',
      month: '月度',
      week: '周度',
      downloadTime: '下载时间',
      uploadTime: '上传时间',
      file: '文件',
      folder: '文件夹',
      department: '部门',
    },
  },
  dialog: {
    departmentAdd: '创建部门',
    departmentEdit: '编辑部门',
    delaerStatus: '启用用户',
    delaerDisabled: '禁用用户',
    deleteDepartment: '删除部门',
    deleteRole: '删除角色',
    roleAdd: '创建角色',
    roleEdit: '编辑角色',
    userEdit: '编辑用户',
    dealer: '经销商',
    internalUsers: '内部用户',
    enUsed: '禁用用户后，用户的部门/角色将被清除，是否确认禁用？',
    disabledTitle: '确认提示',
    secondenUsed: '是否确认禁用？',
    deleteFolder: '删除文件夹',
    deleteFile: '删除文件',
    folderAdd: '创建文件夹',
    folderEdit: '修改文件夹',
    copyTo: '复制到',
    moveTo: '移动到',
    muchDelete: '批量删除',
    content: {
      fileOne:
        '支持的文件类型有：pdf、wav、mov、mp4、wmv、mp3、jpg 、jpeg、png 、gif、zip、rar、7z、doc、docx、xlsx、xls、pptx、ppt、mpg、ai、psd、tif。',
      fileTwo: '单个文件最大：4GB',
      fileThree: '文件有效时间：1年',
      expireNotice: '到期的文件将被清除，请及时备份。',
    },
    upload: {
      noData: '您还没有上传任何文件。',
    },
  },
  confirm: {
    isConfirm: '是否确认删除',
    department: '部门',
    role: '角色',
    isCDeleteFolder: '是否确认删除此文件夹？',
    isCDeleteFile: '是否确认删除此文件？',
    destinationFolder: '目标文件夹',
    moveExpireTime: '移动文件，过期的时间不重新计算。',
    copyExpireTime: '文件过期时间：',
    copyExpireTimeTwo: '过期的文件会被清理，请及时备份。',
    deleteMuchFile: '是否确认删除所选文件夹/文件？',
    deleteFileBeing: '是否确认删除正在上传的文件?',
    leaveFileBeing: '当前有文件正在上传，离开本页面上传将终止。是否离开？',
  },
  message: {
    del: '删除成功！',
    add: '创建成功！',
    update: '编辑成功！',
    delError: '删除失败！',
    updateError: '编辑失败！',
    addError: '创建失败！',
    use: '用户启用成功！',
    disabledUse: '用户禁用成功！',
    saveSuccessful: '保存成功！',
    saveError: '保存失败！',
    saveError_s3: '保存失败（S3）！',
    emptyFile: '文件夹不能为空',
    emptyPermisson: '功能权限不能为空',
    emptyUsers: '用户不能为空',
    hideM: '只能隐藏显示的文件，文件夹不具备显示隐藏操作！',
    showM: '只能显示隐藏的文件，文件夹不具备显示隐藏操作！',
    showSuccess: '显示成功！',
    hideSuccess: '隐藏成功！',
    copySuccess: '复制成功！',
    moveSuccess: '移动成功！',
    shareUrlCopySuccess: '分享链接已复制,可直接粘贴！',
    noContentFound: '未搜索到内容',
    suspend: '暂停',
    failedToUploadShards: '上传分片失败',
    uploadSuccessful: '上传成功',
    mergeShardingFailed: '合并分片失败',
    failedToEstablishConnection: '与bucket建立连接失败',
    startBatchEndtime: '开始时间大于结束时间',
    noRole: '您无权限访问此系统',
    pleaseUserWrite: '请填写分享用户',
    noFileSize: '限制上传超过4G的文件！',
    noUploadBefore: '限制上传',
    noUploadType: '类型',
    roleNoJoyes: '此角色未配置菜单权限，请选择其他角色',
    dashboardNotice: '统计信息包括逻辑删除的文件夹/文件。',
  },
}
